import {
    ADD_PERSONA_AUDIENCE,
    ADD_CONTENT_TYPE_LIST,
    ADD_VEEVA_SPECILTY_LIST,
    ADD_PERSONA_AUDIENCE_LIST,
    ADD_PERSONA_GROUP_LIST,
    ADD_COUNTRY,
} from "./actionTypes";

// need to call at persoane create on chnage method and store in redux
export const setOnChangePersonaAudience = (payload: any) => {
    return {
        type: ADD_PERSONA_AUDIENCE,
        payload: { ...payload },
    };
};

export const setContentTypeList = (payload: any) => {
    return {
        type: ADD_CONTENT_TYPE_LIST,
        payload: [...payload],
    };
};

export const setVeevaSpecialtyList = (payload: any) => {
    return {
        type: ADD_VEEVA_SPECILTY_LIST,
        payload: { ...payload },
    };
};

export const setPersonaList = (payload: any) => {
    return {
        type: ADD_PERSONA_AUDIENCE_LIST,
        payload: [...payload],
    };
};

export const setPersonaGroupList = (payload: any) => {
    return {
        type: ADD_PERSONA_GROUP_LIST,
        payload: [...payload],
    };
};
export const setCountry = (payload: any) => {
    return {
        type: ADD_COUNTRY,
        payload,
    };
};
